/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/github" */ '@atlassian/logo-third-party/github'
		).then((m) => m.GitHubIcon),
	{ moduleId: '@atlassian/logo-third-party/github' },
);

const LazyGithubIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-github" */ './utils').then((m) => m.GithubIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/github/icon' },
);

const LazyGithubSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-github-search-result" */ './utils').then(
			(m) => m.GithubSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GithubIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyGithubIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const GithubSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyGithubSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
